import type { MapTab } from '@gettactic/api';
import React from 'react';
export interface SettingsState {
  designSystem: string;
  switchDesignSystem: (version: 'v1' | 'v2') => Promise<void>;
  organizationIsAfterForceDate: boolean;
  isLoading: boolean;
  haveConfetti: boolean;
  throwConfetti: () => void;
  isOfficePrivacyEnabled: (officeId: string | undefined) => boolean;
  /** Map side-panel tabs to render, in the organization's chosen order. */
  mapTabs: MapTab[];
  isOrganizationSettingsLoading: boolean;
}

export const SettingContext = React.createContext<SettingsState | undefined>(
  undefined
);

export const useSettings = () => {
  const context = React.useContext(SettingContext);
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
};
